export var RecordingOrigin;
(function (RecordingOrigin) {
    RecordingOrigin["CS"] = "cs";
    RecordingOrigin["CT"] = "ct";
    RecordingOrigin["ALL"] = "all";
})(RecordingOrigin || (RecordingOrigin = {}));
//# sourceMappingURL=recording-origin.js.map